<script setup lang="ts">
import {onUnmounted, type PropType} from "vue";
import Translator from "@/utils/common/Translator";
import {useMessagesStore} from "@/stores/ToastDataStore";
import {NamaWarning} from "@/utils/presenters/interfaces.ts";

let props = defineProps({
  messages: {
    required: true,
    type: Object as PropType<NamaWarning[]>,
  }
});

onUnmounted(() => {
  useMessagesStore().clearMessages();
})
</script>

<template>
  <div class="tw-flex tw-justify-between tw-w-full !tw-inline-block">
    <div class="tw-flex tw-flex-wrap tw-flex-row tw-gap-2 tw-overflow-auto tw-max-h-[50vh]">
      <template v-for="(message, index) of messages" :key="index">
        <template v-if="message.message && message.message.englishText">
          <q-card class=" tw-w-full tw-shadow-none" :class="[message.warning ? 'tw-bg-yellow-400 dark:tw-bg-yellow-700' :'tw-bg-green-300 dark:tw-bg-green-900']">
            <q-card-section class="tw-p-2 tw-font-normal tw-text-base tw-max-h-[50vh] tw-text-namaFontColor-input-light dark:tw-text-white"
                            v-html="Translator.translateNaMaText(message.message)"/>
          </q-card>
        </template>
      </template>
      </div>
    </div>
</template>
<style>

</style>
